<template>
<div>
    <div class="demo-upload-list" v-for="item in uploadList" :key="item.key">
        <template v-if="item.status === 'finished'">
            <!-- <button disabled="disabled"></button> -->
            <span>{{nameVal}}</span>
            <Icon type="ios-document-outline"  size="50"/>
            
            <div class="demo-upload-list-cover">
                <Icon type="ios-trash-outline"    @click.native="handleRemove(item)"/>
            </div>
        </template>
        <template v-else>
            <Progress v-if="item.showProgress" :percent="item.percentage" hide-info></Progress>
        </template>
    </div>
    <Upload
        ref="upload"
        :show-upload-list="false"
        :default-file-list="defaultList"
        :on-success="handleSuccess"
        :on-error="handleError"
        :format="types"
        :max-size="5000000"
        :on-format-error="handleFormatError"
        :on-exceeded-size="handleMaxSize"
        :before-upload="handleBeforeUpload"
        :data="token"
        type="drag"
        :action="action"
        style="display: inline-block;width:58px;">
        <div style="width: 58px;height:58px;line-height: 58px;" >
            <!-- <Icon type="ios-camera" size="20"></Icon> -->
            <Icon type="ios-cloud-upload" size="20"/>
        </div>
    </Upload>
    
</div>
</template>
<script>
/**
 * 图片上传组件
 * @param num Number 允许上传的数量
 * @param action String 上传接口
 * @param hasUpload Array 已上传的图片
 * hasUpload格式
 * {
 * status:'finished',
      name: 'a42bdcc1178e62b4694c830f028db5c0',
      response:{data:'http://www.blshop.com/upload/common/20180810/fcb98054a116becbf41d941d1fc64dcb.png'}
    }
    setThumbUrl 为上传成功后回调的父组件的方法，在父组件中添加此方法
 */
import common from "@/common/common.js"
import { mapState } from 'vuex'
    export default {
        name:"imgUpload",
        props:{
            num:Number,//允许上传个数
            action:String,//传入上传接口
            fileDisabled:Boolean,
            formatError:{
                type:String,
                default:""
            },
            types: {
                type: Array,
                default: ()=>{return ['xlsx','xls']}
            },
        },
        data () {
            return {
                token:{},
                webUrl:this.config.urlArray.url,
                defaultList: [],//默认图片
                imgName: '',
                uploadList: [],//已上传的图片列表
                nameVal:""
            }
        },
        computed:{
            ...mapState(['local']),
        },
        watch:{
           fileDisabled(val){
               if(val){
                //    console.log('222222')
                 this.handleRemove()
               }
           }
        },
        methods: {
            handleRemove (file) {//删除图片
                const fileList = this.$refs.upload.fileList;
                let index = fileList.indexOf(file)
                this.$refs.upload.fileList.splice(fileList.indexOf(file), 1);
                this.$emit('removeThumbUrl',index);
            },
            clearImg () {//清除所有文件
                this.$refs.upload.clearFiles()
                this.uploadList = this.$refs.upload.fileList;
            },
            handleSuccess (res, file) {//上传成功后的处理方法
                this.$emit('setThumbUrl',{data:res.data,file:file});
                this.nameVal = file.name;
                if(res.code==1){

                    this.$Notice.success({
                        title: this.$t('img.success')
                    })
                }
            },
            handleError(error, file, fileList){
                // console.log('error',error)
                // console.log('file',file)
                this.$Message.error(file.error)
            },
            handleFormatError (file) {//上传错误提示
                let typesTxt = this.types.join('、')
                this.$Notice.warning({
                    title:this.$t('upError.formatError'),
                    desc:this.formatError?this.formatError: file.name + this.$t('upError.formatError')+ this.$t('upError.pleaseSele')+typesTxt+this.$t('upError.type')
                });
            },
            handleMaxSize (file) {//大小提示, Nginx配置的限制大小，要记得改
                this.$Notice.warning({
                    title: 'Exceeding file size limit',
                    // desc: '文件  ' + file.name + ' 太大，不能超过500KB'
                });
            },
            handleBeforeUpload () {//上传数量限制
                const check = this.uploadList.length < this.num;
                let tip_zh = `最多只能上传 ${this.num} 个文件`
                let tip_en = `You can upload up to ${this.num} files maximum`
                if (!check) {
                    this.$Notice.warning({
                        title: this.local=='zh-CN'?tip_zh:tip_en
                    });
                }
           
                return check;
            },
            setHasUpload (hasUpload) {//编辑时赋值
                this.$refs.upload.fileList = hasUpload
                this.uploadList = this.$refs.upload.fileList;
            }
        },
        mounted () {
            this.token.token = common.getToken() || localStorage.getItem('token')
            // this.token.merchant_id = -1
            this.uploadList = this.$refs.upload.fileList;
            
        }
    }
</script>
<style>
    .demo-upload-list{
        display: inline-block;
        width: 60px;
        height: 60px;
        text-align: center;
        line-height: 60px;
        border: 1px solid transparent;
        border-radius: 4px;
        overflow: hidden;
        background: #fff;
        position: relative;
        box-shadow: 0 1px 1px rgba(0,0,0,.2);
        margin-right: 4px;
    }
    .demo-upload-list img{
        width: 100%;
        height: 100%;
    }
    .demo-upload-list-cover{
        display: none;
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        background: rgba(0,0,0,.6);
    }
    .demo-upload-list:hover .demo-upload-list-cover{
        display: block;
    }
    .demo-upload-list-cover i{
        color: #fff;
        font-size: 20px;
        cursor: pointer;
        margin: 0 2px;
    }
</style>
